import Flickity from "flickity";

const initTestimonials = (testimonials) => {
    const carousel = testimonials.querySelector(".js-carousel");
    const carouselPrev = testimonials.querySelector(".js-carousel-prev");
    const carouselNext = testimonials.querySelector(".js-carousel-next");

    const flickityOptions = {
        cellAlign: "left",
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        setGallerySize: true,
        cellSelector: ".js-slide",
        adaptiveHeight: true
    };

    const flkty = new Flickity(carousel, flickityOptions);

    if (carouselPrev) {
        carouselPrev.addEventListener("click", () => {
            flkty.previous();
        });
    }

    if (carouselNext) {
        carouselNext.addEventListener("click", () => {
            flkty.next();
        });
    }
};

export { initTestimonials as default };
